import { render, staticRenderFns } from "./addedManualQuotationRules.vue?vue&type=template&id=9f4b5242&scoped=true&"
import script from "./addedManualQuotationRules.vue?vue&type=script&lang=js&"
export * from "./addedManualQuotationRules.vue?vue&type=script&lang=js&"
import style0 from "./addedManualQuotationRules.vue?vue&type=style&index=0&id=9f4b5242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4b5242",
  null
  
)

export default component.exports